import { clientLanguagesData } from "Shared/TranslatableTextContent/clientLanguagesData";
import useLanguage from "./useLanguageFlow";
import useTranslatableFlow from "./useTranslatableFlow";

export default function useGenericTranslateFlow<T extends string | number | symbol>({ textContent, languageOverride = null, translatableConfiguration = {} }) {
  const language: string = languageOverride || useLanguage()

  const translated = useTranslatableFlow<T>({ textContent, useFallback: false, language: languageOverride, translatableConfiguration })
  const fallback = useTranslatableFlow<T>({ textContent, useFallback: true, language: languageOverride, translatableConfiguration })

  const clientLanguages = clientLanguagesData()
  const flag = Object.keys(clientLanguages).length > 1 ? clientLanguages[language]?.flag || '' : ''

  return {
    language,
    translated,
    fallback,
    flag
  }
}
